import React from "react";
// Import the main component
import { Viewer, Worker } from "@react-pdf-viewer/core";

// Plugins
import { getFilePlugin } from "@react-pdf-viewer/get-file";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import { MostrarPdf } from "./MostrarPdf";

export const ModalDocumento = ({ id, documentoByte }) => {


  const handleDownload=()=>{
    if (documentoByte!=null) {
        const base64toBlob = (data) => {
            const bytes = atob(data);
            let length = bytes.length;
            let out = new Uint8Array(length);
        
            while (length--) {
              out[length] = bytes.charCodeAt(length);
            }
        
            return new Blob([out], { type: 'application/pdf' });
          };
        
        const blob = base64toBlob(documentoByte);
        const url = URL.createObjectURL(blob);

         // Crear un elemento "a" para descargar el archivo
         const a = document.createElement('a');
         a.href = url;
         a.download = `documento.pdf`;
         
         // Simular un clic en el elemento "a" para iniciar la descarga
         a.click();
         URL.revokeObjectURL(url);  
    }
         
}

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby={id}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Documentos</h5>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span className="svg-icon svg-icon-1 ">
                <svg
                  xmlns="http://www.w3.org/2000/svg "
                  width="24 "
                  height="24 "
                  viewBox="0 0 24 24 "
                  fill="none "
                >
                  <rect
                    opacity="0.5 "
                    x="6 "
                    y="17.3137 "
                    width="16 "
                    height="2 "
                    rx="1 "
                    transform="rotate(-45 6 17.3137) "
                    fill="currentColor "
                  ></rect>
                  <rect
                    x="7.41422 "
                    y="6 "
                    width="16 "
                    height="2 "
                    rx="1 "
                    transform="rotate(45 7.41422 6) "
                    fill="currentColor "
                  ></rect>
                </svg>
              </span>
            </div>
          </div>
          <div className="modal-body">
            {documentoByte === null ? (
              <div className="alert alert-warning" role="alert">
                <strong>Atención, </strong>No existe documento para mostrar.
              </div>
            ) : (
              <MostrarPdf documentoByte={documentoByte}></MostrarPdf>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-info"
              onClick={handleDownload}
            >
              Descargar
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
